import React, { Fragment } from "react";
import {
  FormControlLabel,
  FormGroup,
  Checkbox,
  Typography,
  Button,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";

function ViewResult() {
  return (
    <Fragment>
      <Typography component="subtitle2" align="center">
        전체 동의는 신원 특판 멤버십 서비스의 모든 동의를 포함하고 있습니다.
        선택에 대한 동의를 거부해도 서비스 이용이 가능합니다.
      </Typography>
      <hr />
    </Fragment>
  );
}
function AllYn(props) {
  const classes = props.useStyles();
  const handleChangeAllYn = (e) => {
    props.onChangeTotalAllYn(e.target.checked);
  };
  const [showResults, setShowResults] = React.useState(false);
  const onView = (e) => {
    e.preventDefault();
    setShowResults(!showResults);
  };
  return (
    <>
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              checked={props.totalAllYn}
              onChange={handleChangeAllYn}
              name="allYn"
            />
          }
          label={
            <Typography className={classes.TypographyFont}>
              전체 동의
            </Typography>
          }
        />
        <Button
          className={classes.Button}
          variant="text"
          color="primary"
          type="submit"
          onClick={onView}
          startIcon={<VisibilityIcon />}
        >
          내용보기
        </Button>
      </FormGroup>

      <hr />
      {showResults ? <ViewResult /> : null}
    </>
  );
}

export default AllYn;
